import { render, staticRenderFns } from "./DeleteTag.vue?vue&type=template&id=b955d816"
import script from "./DeleteTag.vue?vue&type=script&lang=js"
export * from "./DeleteTag.vue?vue&type=script&lang=js"
import style0 from "./DeleteTag.vue?vue&type=style&index=0&id=b955d816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports